export class Inquiry {
    fullName: string;
    email: string;
    message: string;
    numberOfAdults: number;
    numberOfChilds: number;
    type: string;

    constructor() {
        this.fullName = '';
        this.email = '';
        this.message = '';
        this.numberOfAdults = null;
        this.numberOfChilds = null;
        this.type = '';
    }
}